import React, { Component } from 'react';
import moment from 'moment';
import { Row, Col, Tooltip, Button, Checkbox, Form, Icon, Divider } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';

class DataEntry extends Component {
    constructor(props) { super(props); }

    updatePreference(e) {
        const p = this.props;
        if(!p.preferencesChanged) p.togglePreferencesChanged();
        p.service(e);
    }

    render() {
        const
        p = this.props,
        { data } = p;
        return (
            <div>
                <Row style={p.style}>
                    <Col span={5} style={{ textAlign: 'center' }}>
                        <div style={{ margin: '0px 6px' }}>
                            <Checkbox
                                checked={data.optout}
                                name={data.emailTypeCode}
                                onChange={e => this.updatePreference(e)}
                            />
                        </div>
                    </Col>
                    <Col
                        span={19}
                        style={{
                            borderWidth: '1px',
                            borderStyle: 'none none none solid',
                            borderColor: 'rgb(200, 200, 200)'
                        }}
                    >
                        <div style={{ margin: '0px 6px' }}>
                            {data.emailTypeDescription}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default class ManageEmailPreferences extends Component {
    state = { preferencesChanged: false }

    constructor(props) {
        super(props);
        this.togglePreferencesChanged = this.togglePreferencesChanged.bind(this);
    }

    togglePreferencesChanged(override) {
        this.setState({...this.state,
            preferencesChanged: override == null
                ? !this.state.preferencesChanged
                : override
        });
    }

    highlighter() {
        let
        keyPrefix = 'your-account-manage-email-preferences-',
        commonStyle = {
            lineHeight: '30px',
            borderRadius: '4px',
            overflow: 'auto'
        },
        props = (i) => ({
            key: `${keyPrefix}${i}`,
            style: commonStyle
        });
        return arguments[0].map((e, i) => i%2 === 0
            ? React.cloneElement(e, {...props(i), style: {...commonStyle, background: 'rgb(240, 240, 240)' } })
            : React.cloneElement(e, {...props(i)})
        );
    }

    getEmailPreferences() {
        const { services, displayRole } = this.props;
        services.getEmailPreferences(displayRole);
    }

    emailPreferencesUpdateNotice() {
        const { status } = this.props.requests.emailPreferencesUpdate;
        let icon = '', msg = '';

        switch(status) {
            case 'pending':
                icon = 'loading';
                msg = 'Updating Email preferences...';
                break;

            case 'success':
                icon = 'check-circle-o';
                msg = 'Update Successful.';
                break;

            case 'failure':
                icon = 'close-circle-o';
                msg = 'Update Failed.';
                break;

            default: return null;
        }

        return (
            <div style={{ position: 'absolute', top: '15px', left: '10px' }}>
                <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                    <Icon type={icon} />
                    {` ${msg}`}
                </span>
                <div style={{ fontSize: '9px', marginTop: '4px' }}>
                    <span style={{ fontStyle: 'italic' }}>
                        {`Last Updated: ${moment({}).format('YYYY-MM-DD HH:mm:ss')}`}
                    </span>
                </div>
            </div>
        )
    }

    handleSave() {
        const { services, emailPreferences } = this.props;
        services.saveEmailPreferences(emailPreferences);
    }

    componentDidMount() {
        this.getEmailPreferences();
    }

    componentDidUpdate(prev) {
        const
        prevEmailUpdateStatus = prev.requests.emailPreferencesUpdate.status,
        currEmailUpdateStatus = this.props.requests.emailPreferencesUpdate.status;

        if(prevEmailUpdateStatus === 'pending' && currEmailUpdateStatus === 'success')
            this.setState({...this.state, preferencesChanged: false });
    }

    render() {
        const
        p = this.props,
        { services, requests } = p,
        { status } = requests.emailPreferences;

        switch(status) {
            default: return (
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                <Icon type='loading' />
                                {' Attempting to load preferences...'}
                            </span>
                        </Col>
                    </Row>
                </div>
            );

            case 'pending': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                <Icon type='loading' />
                                {' Loading preferences...'}
                            </span>
                        </Col>
                    </Row>
                </div>
            );

            case 'failure': return (
                <div>
                    <div style={{ position: 'absolute', top: '148px', left: '10px' }}>
                        <Tooltip placement='right' title='Close email preferences.'>
                            <Button
                                icon='arrow-left'
                                shape='circle'
                                onClick={() => services.changeView(VIEWS.YOUR_ACCOUNT)}
                            />
                        </Tooltip>
                    </div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                <Icon type='close-circle-o' />
                                {' Unable to load preferences.'}
                            </span>
                            <div style={{ textAlign: 'center' }}>
                                <span style={{ fontStyle: 'italic', fontSize: '9px' }}>
                                    {`Last Updated: ${moment({}).format('YYYY-MM-DD HH:mm:ss')}`}
                                </span>
                            </div>
                        </Col>
                    </Row>
                </div>
            );

            case 'success': return (
                <div style={{ maxHeight: '280px', overflow: 'scroll' }}>
                    {this.emailPreferencesUpdateNotice()}
                    <div style={{ position: 'absolute', top: '68px', right: '10px' }}>
                        <Tooltip placement='left' title='Save Email Preferences.'>
                            <Button
                                icon='save'
                                type='primary'
                                onClick={() => this.handleSave()}
                                disabled={this.state.preferencesChanged ? false : true}
                            >
                                {'Save'}
                            </Button>
                        </Tooltip>
                    </div>
                    <div style={{ position: 'absolute', top: '68px', left: '10px' }}>
                        <Tooltip placement='right' title='Close email preferences.'>
                            <Button
                                icon='arrow-left'
                                shape='circle'
                                onClick={() => {
                                    services.resetEmailPreferencesUpdate();
                                    services.changeView(VIEWS.YOUR_ACCOUNT);
                                }}
                            />
                        </Tooltip>
                    </div>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '3px' }}>
                        <Col span={23}>
                            <span style={{ fontStyle: 'italic' }}>
                                {'Select the emails you would like to opt out of below.'}
                            </span>
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '16px' }}>
                        <Col span={p.noIcon ? 15 : 23}>
                            <span style={{ fontStyle: 'italic' }}>
                                {'Emails that you opt not to receive will still be available '}
                                {'to you on this site\'s Email page.'}
                            </span>
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={21}>
                            <div style={{
                                lineHeight: '26px',
                                borderRadius: '4px',
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderColor: 'rgb(240, 240, 240)',
                                marginBottom: '10px'
                            }}>
                                <Row>
                                    <Col span={5}>
                                        <div style={{ marginLeft: '6px' }}>
                                            {'Opt out?'}
                                        </div>
                                    </Col>
                                    <Col
                                        span={19}
                                        style={{
                                            borderWidth: '1px',
                                            borderStyle: 'none none none solid',
                                            borderColor: 'rgb(200, 200, 200)'
                                        }}
                                    >
                                        <div style={{ marginLeft: '6px' }}>
                                            {'Email Subject'}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {this.highlighter(p.emailPreferences.map(d => (
                                <DataEntry
                                    data={d}
                                    service={services.updateEmailCheckbox}
                                    preferencesChanged={this.state.preferencesChanged}
                                    togglePreferencesChanged={this.togglePreferencesChanged}
                                />
                            )))}
                        </Col>
                    </Row>
                </div>
            );
        }
    }
}
